import "rc-dialog/assets/index.css";

import classnames from "classnames";
import Dialog from "rc-dialog";
import React from "react";
import { WithTranslation, withTranslation } from "react-i18next";

import BalancePanel from "../../BalancePanel/BalancePanel";
import BonusPanel from "../../BonusPanel/BonusPanel";
import StatusBarButton from "../../StatusBarButton/StatusBarButton";

// tslint:disable-next-line:no-var-requires
const style = require("./AnonymousStatusBar.scss");

export interface AnonymousStatusBarProps {
    readonly vouchersEnabled: boolean;
    readonly balance: number;
    readonly bonusValue: string;
    readonly currency: string;
    readonly onPrintVoucher: () => void;
}

export interface AnonymousStatusBarState {
    readonly showingVoucherPopup: boolean;
}

export class AnonymousStatusBar extends React.Component<
    AnonymousStatusBarProps & WithTranslation,
    AnonymousStatusBarState
> {
    private mousePosition: { x: number; y: number } | undefined;
    constructor(props: AnonymousStatusBarProps & WithTranslation) {
        super(props);
        this.state = { showingVoucherPopup: false };
    }
    public componentDidMount() {
        document.addEventListener("click", this.mouseHandler, true);
    }

    public componentWillUnmount() {
        document.removeEventListener("click", this.mouseHandler);
    }

    public render() {
        return (
            <div className={classnames(style.statusBar)}>
                {this.renderBalanceSection()}
                <BonusPanel
                    className={classnames(style.bonus)}
                    bonusValue={this.props.bonusValue}
                    formatBonus={this.formatBonus}
                />
                <Dialog
                    visible={this.state.showingVoucherPopup}
                    animation="zoom"
                    maskAnimation="fade"
                    mousePosition={this.mousePosition}
                    wrapClassName={classnames(style.darkDialog)}
                    title={this.props.t("Print voucher confirm")}
                >
                    <p>{this.formatVoucherDialogMessage()}</p>
                    <footer>
                        <button
                            className="printVoucher"
                            onClick={this.printVoucher}
                        >
                            {this.props.t("Print")}
                        </button>
                        <button
                            className="cancelPrintingVoucher"
                            onClick={this.hideVoucherPopup}
                        >
                            {this.props.t("Cancel")}
                        </button>
                    </footer>
                </Dialog>
            </div>
        );
    }
    private renderVoucherButton() {
        return (
            this.props.vouchersEnabled && (
                <StatusBarButton
                    onClick={this.showVoucherPopup}
                    className={classnames(style.voucher)}
                >
                    {this.props.t("Print voucher")}
                </StatusBarButton>
            )
        );
    }

    private renderBalanceSection() {
        return (
            this.props.balance > 0 && (
                <>
                    {this.renderVoucherButton()}
                    <BalancePanel
                        anonymous={true}
                        className={classnames(style.balance)}
                        balance={this.props.balance}
                        balanceTextFormat={this.formatBalance}
                        currency={this.props.currency}
                    />
                </>
            )
        );
    }

    private formatVoucherDialogMessage = () =>
        this.props.t("Print voucher for", {
            credit: this.props.balance,
            currency: this.props.currency
        });
    private formatBalance = (balance: number) => {
        return this.props.t("Balance", {
            balance: balance.toFixed(2),
            currency: this.props.currency
        });
    };
    private formatBonus = (bonus: string) => this.props.t("Bonus", { bonus });

    private printVoucher = () => {
        this.props.onPrintVoucher();
        this.setState({ showingVoucherPopup: false });
    };

    private hideVoucherPopup = () =>
        this.setState({
            showingVoucherPopup: false
        });

    private showVoucherPopup = () =>
        this.setState({
            showingVoucherPopup: true
        });

    private mouseHandler = (e: MouseEvent) =>
        (this.mousePosition = { x: e.pageX, y: e.pageY });
}

export default withTranslation("anonymousStatusBar")(AnonymousStatusBar);
